import { TimeSlot as Slots } from '@homeserve/od-typings/api';
import { Moment } from 'moment';

export enum PriceOption {
  customerBasePurchasePrice = 'customerBasePurchasePrice',
  customerExtraChargeNights = 'customerExtraChargeNights',
  customerExtraChargeSundays = 'customerExtraChargeSundays',
}

export interface TimeSlot {
  cost?: PriceOption;
  date?: Moment;
  slot?: Slots;
  hasNoPreference?: boolean;
}

export interface ISlotDisplay {
  cost: PriceOption;
  display: string;
}

export interface TimeOption {
  date: Moment;
  isInflated: boolean;
  slots: { [key in Slots]?: ISlotDisplay };
}
export interface ISlot {
  start: number;
  end: number;
}

export interface ISlots {
  am: ISlot;
  pm: ISlot;
  evening: ISlot;
}
export const slots: ISlots = {
  am: {
    start: 8,
    end: 13,
  },
  pm: {
    start: 13,
    end: 19,
  },
  evening: {
    start: 19,
    end: 22,
  },
};

export interface IPriceAdjust {
  appointmentDate: string;
  extra?: number;
  finalPrice: number;
}
